<div class="ag-header-group-cell-label">
  <div [ngClass]="{ 'skip-text-transform': $safeNavigationMigration(params()?.skipTextTransform) }" class="customHeaderLabel">
    {{ $safeNavigationMigration(params()?.displayName) | translate }}
  </div>
  @if (showExpandArrow()) {
    <div class="customExpandButton" [ngClass]="expandState()" (click)="expandOrCollapse()">
      <i class="fa-solid fa-arrow-right" aria-hidden="true"></i>
    </div>
  }
</div>
